module.exports = __webpack_public_path__ + "4899adf1afccc4b2e86d06a8f74cdf0b.pdf";